import {LocationCalculator} from "../helpers/LocationCalculator";
import {testStakeholderIsStaff} from "../helpers/tools";

export const pureLocations = [
  {
    id: "DHT",
    type: "district",
    name: "District Health Team",
    adoption: 0,
    stakeholders: [
      {
        id: "EPI",
        title: "EPI Focal Point",
        img: "/img/changemanagement/img-EPI-focal-point@2x.png",
        ability: 40,
        motivation: 30,
      },
      {
        id: "HO",
        title: "Health Officer",
        img: "/img/changemanagement/img-health-officer@2x.png",
        ability: 40,
        motivation: 10,
      },
    ],
    theme: "bg-brand-blue-300",
    img: "/img/changemanagement/DHT.png",
  },
  {
    id: "FacilityA",
    type: "facility",
    name: "Facility A",
    adoption: 0,
    stakeholders: [
      {
        id: "managerA",
        type: "facilityManager",
        title: "Manager",
        img: "/img/changemanagement/img-manager@2x.png",
        ability: 30,
        motivation: 70,
      },
      {
        id: "vaccinatorA",
        title: "Vaccinator",
        img: "/img/changemanagement/img-vaccinator-a@2x.png",
        ability: 20,
        motivation: 60,
      },
      {
        id: "communityA",
        title: "Community",
        img: "/img/changemanagement/facility-a.png",
        participation: 20,
      },
    ],
    theme: "bg-brand-orange-600",
    img: "/img/changemanagement/facility-a.png",
  },
  {
    id: "FacilityB",
    type: "facility",
    name: "Facility B",
    adoption: 0,
    stakeholders: [
      {
        id: "managerB",
        type: "facilityManager",
        title: "Manager",
        img: "/img/changemanagement/img-facility-b@2x.png",
        ability: 10,
        motivation: 0,
      },
      {
        id: "vaccinatorB",
        title: "Vaccinator",
        img: "/img/changemanagement/img-vaccinator@2x.png",
        ability: 10,
        motivation: 20,
      },
      {
        id: "communityB",
        title: "Community",
        img: "/img/changemanagement/facility-b.png",
        participation: 5,
      },
    ],
    theme: "bg-brand-green-200",
    img: "/img/changemanagement/facility-b.png",
  },
  {
    id: "FacilityC",
    type: "facility",
    name: "Facility C",
    adoption: 0,
    stakeholders: [
      {
        id: "managerC",
        type: "facilityManager",
        title: "Manager",
        img: "/img/changemanagement/img-facility-b-1@2x.png",
        ability: 5,
        motivation: 5,
      },
      {
        id: "vaccinatorC",
        title: "Vaccinators",
        img: "/img/changemanagement/img-vaccinator-c@2x.png",
        ability: 5,
        motivation: 5,
      },
      {
        id: "communityC",
        title: "Community",
        img: "/img/changemanagement/facility-c.png",
        participation: 5,
      },
    ],
    theme: "bg-brand-green-500",
    img: "/img/changemanagement/facility-c.png",
  },
];

/**
 *
 * @param history
 * @param prevHistory
 * @param metrics
 * @returns {(*|{stakeholders: *}|{adoption: number})[]}
 */
export function fetchLocations(history, prevHistory, metrics=0) {
  // User actions calculation
  let data = pureLocations.map(each => {
    const calculator = new LocationCalculator(each, history);
    return {
      ...each,
      stakeholders: calculator.calculateUserActionsResults(each.stakeholders),
    }
  });

  if (prevHistory) {
    // Motivation Reduction Lack of Celebration of “Quick Wins”
    data = data.map(each => {
      const calculator = new LocationCalculator(each, history);
      return {
        ...each,
        stakeholders: calculator.calculateMotivationReduction(each.stakeholders),
      }
    });
  }

  // Community Participation Calculation
  data = data.map(each => {
    const calculator = new LocationCalculator(each, history);
    return {
      ...each,
      stakeholders: calculator.calculateCommunityParticipation(each.stakeholders),
    }
  });

  // Adoption Calculation
  data = data.map(each => {
    const calculator = new LocationCalculator(each, history);
    return {
      ...each,
      adoption: calculator.calculateAdoptionRate()
    }
  });
  if (history && prevHistory && metrics) {
    const prevData = fetchLocations(prevHistory);
    data = data.map((each, i) => {
      const prevLocation = prevData[i];
      return {
        ...each,
        prev_adoption: prevLocation.adoption,
        stakeholders: each.stakeholders.map((stakeholder, j) => {
          const prevStakeholder = prevLocation.stakeholders[j];
          if (testStakeholderIsStaff(stakeholder)) {
            return {
              ...stakeholder,
              prev_motivation: prevStakeholder.motivation,
              prev_ability: prevStakeholder.ability,
            };
          } else {
            return {
              ...stakeholder,
              prev_participation: prevStakeholder.participation,
            };
          }
        })
      }
    });
  }
  return data;
}

